package net.lateinit.bug_or_feature.site.util

import kotlin.js.json

@JsModule("@vercel/analytics")
@JsNonModule
private external object VercelAnalyticsModule {
    fun inject(options: dynamic = definedExternally)
}

fun initVercelAnalytics() {
    VercelAnalyticsModule.inject(json("mode" to "auto"))
}
